import { DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { MomentDateAdapter } from '@angular/material-moment-adapter';
import { NotificationsService } from 'angular2-notifications';
import { AppService } from '../../../../../app/app.service';
import { OrdinalDateParse } from '../../adapters/ordinal-date-adapter';
import { LeaveRequestAuditTrail, NewLeaveInfo } from '../../entities/global/model';
import { MY_FORMATS } from '../../search-form-analysisreporting/search-form-analysisreporting.component';
import { SafetyConfigService } from '../../services/safety-config.service';
import { SafetyLeavesService } from '../../services/safety-leaves.service';
import { CreateNewLeaveComponent } from '../create-new-leave/create-new-leave.component';
import { DateAdapter, MAT_DATE_LOCALE, MAT_DATE_FORMATS } from '@angular/material/core';
import { MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'app-search-leaves',
  templateUrl: './search-leaves.component.html',
  styleUrls: ['./search-leaves.component.scss'],
  providers: [
    DatePipe,
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE]
    },
    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
    { provide: MAT_DATE_LOCALE, useValue: 'en-au' }
  ],
})
export class SearchLeavesComponent implements OnInit {

  endDate: Date = new Date();
  startDate: Date = new Date(new Date().setDate(new Date().getDate() - 7));

  LeaveRequestList:NewLeaveInfo[]=[];
  LeaveAuditTrailList:LeaveRequestAuditTrail[]=[];

  constructor(private _appService: AppService,
    private _dialog: MatDialog,
    private _notify: NotificationsService,
    private _safetyConfigService: SafetyConfigService,
    private _safetyLeaves :SafetyLeavesService) { }
    ord: OrdinalDateParse = new OrdinalDateParse();
  ngOnInit() {
    this._appService.setPageTitle('Search Leave');
  }

  ResetFields(){
    this.endDate = new Date();
  this.startDate= new Date(new Date().setDate(new Date().getDate() - 7));
  }
  OpenNewLeaveRequest(){
    const createnewRSHDialog = this._dialog.open(CreateNewLeaveComponent, {
      panelClass: 'removeModalOverflow',
      data: {
          title:"New Leave Request",
          IsEdit:false,
      }, 
      minWidth: 500,
      disableClose: true,
  });

  createnewRSHDialog.afterClosed().subscribe(createnewRSH => {
    this.LoadAllTheLeaveRequests();
  });
  }

  LoadAllTheLeaveRequests(){
const params = new NewLeaveInfo();
params.LeaveFrom=this.startDate;
params.LeaveTo=this.endDate;


let _StartDate =this.startDate? this.ord.formatDateOrdinal((this.startDate.toString())
.split(' ')
.slice(1)
.join(' '), false):this.startDate;
let _EndDate = this.endDate?this.ord.formatDateOrdinal((this.endDate.toString())
.split(' ')
.slice(1)
.join(' '), false):this.endDate;

params.LeaveFrom_ = _StartDate;
params.LeaveTo_ = _EndDate;

    this._safetyLeaves.GETAllLeaveRequests(params).subscribe(res=>{
      this.LeaveRequestList =res;
      

    })
  }

  SearchLeaves(){
this.LoadAllTheLeaveRequests();
  }

  ChangeExpand(sr:NewLeaveInfo){
    sr.IsExpand = !sr.IsExpand
   
  }


  LoadLeaveInfo(leave:NewLeaveInfo){
    const createnewRSHDialog = this._dialog.open(CreateNewLeaveComponent, {
      panelClass: 'removeModalOverflow',
      data: {
          title:"Update Leave Request",
          IsEdit:true,
          LeaveInfo:leave
      }, 
      minWidth: 500,
      disableClose: true,
  });

  createnewRSHDialog.afterClosed().subscribe(createnewRSH => {
    this.LoadAllTheLeaveRequests();
  });
  }

}
